import { Controller } from '@hotwired/stimulus'

import { trackReportEvent } from '@app/application/report/report-tracking'

// Mounted outside the table turbo-frame, so it connects once per full-page open
// rather than on every frame sub-request.
export default class extends Controller {
  connect(): void {
    trackReportEvent('Reports: Report Opened')
  }
}
